<template>
  <div class="card">
    <div class="card-body">
      <h4 class="card-title">Positive Identification Enrollment</h4>
      <p class="text-muted">
        Enroll a staff member's badge or fingerprint for positive identification.
      </p>

      <!-- User search -->
      <div class="form-group">
        <label class="pi-label">Find user</label>
        <div class="d-flex">
          <b-form-input
            v-model="searchTerm"
            placeholder="Name, username, or initials"
            @keyup.enter="searchUsers"
          />
          <b-button class="ml-2" variant="primary" :disabled="searching" @click="searchUsers">Search</b-button>
        </div>
      </div>

      <b-list-group v-if="results.length" class="mb-3">
        <b-list-group-item
          v-for="u in results"
          :key="u.userName"
          button
          :active="selectedUser && selectedUser.userName === u.userName"
          @click="selectUser(u)"
        >
          {{ u.firstName }} {{ u.lastName }} <span class="text-muted">({{ u.userName }})</span>
        </b-list-group-item>
      </b-list-group>

      <!-- Selected user + shared enrollment form -->
      <div v-if="selectedUser" class="selected-user">
        <h5>{{ selectedUser.firstName }} {{ selectedUser.lastName }} ({{ selectedUser.userName }})</h5>
        <PositiveIdEnrollmentForm :user-name="selectedUser.userName" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';
import PositiveIdEnrollmentForm from '@/components/Common/PositiveIdEnrollmentForm.vue';
import { NotificationOptions } from '@/util/NotificationOptionsPresets';

interface StaffUser {
  userName: string;
  firstName: string;
  lastName: string;
}

@Component({ name: 'PositiveIdEnrollmentPage', components: { PositiveIdEnrollmentForm } })
export default class PositiveIdEnrollmentPage extends Vue {
  private searchTerm = '';
  private searching = false;
  private results: StaffUser[] = [];
  private selectedUser: StaffUser | null = null;

  async searchUsers(): Promise<void> {
    if (!this.searchTerm.trim()) return;
    this.searching = true;
    try {
      const response = await axios.get<StaffUser[]>('/User', { params: { searchTerm: this.searchTerm.trim() } });
      this.results = response.data;
    } catch {
      this.$notification(NotificationOptions.error('Failed to search users.'));
    } finally {
      this.searching = false;
    }
  }

  selectUser(user: StaffUser): void {
    this.selectedUser = user;
  }
}
</script>

<style scoped>
.pi-label { font-weight: 600; }
.selected-user { border-top: 1px solid #e9ecef; margin-top: 1rem; padding-top: 1rem; }
</style>
